export {};

declare global {
  /**
   * 拡張関数
   */
  interface String {
    filterStringNumberUndefinedToString(value: string | number | undefined): string;
    parseNumber(): number;
    parseNumberStringAndRemoveString(): string;
    removeComma(): string;
    escapeStringComma(): string;
    removeNewLineForText(): string;
  }
}

/**
 *　string | number | undefined　を stringに変換する
 * @param value - 文字列
 */
String.prototype.filterStringNumberUndefinedToString = function (value: string | number | undefined) {
  return value ? String(value) : '';
};

/**
 *　入力された文字列からカンマ、ピリオド等の不必要な文字を排除し、numberで返す関数
 */
String.prototype.parseNumber = function (): number {
  let output = this ?? 'error'; // とりあえず、errorと返しておく
  // ピリオド付き数字に対応
  // 230308 一旦ピリオド付き数字（小数点）は何もしないようにしてあります
  // const periodIndex = output.indexOf('.');
  // if (periodIndex !== -1) {
  //   output = output.substring(0, periodIndex);
  // }
  // カンマ付き数字に対応
  output = String(output).replaceAll(',', '');
  // 単位付き数字（25kg等）に対応
  const regex = /[^0-9\.\-,]/g; //　数字,記号のみにmatch　TODO: 正規表現として不適切（考慮不足）なので要対応
  output = output.replace(regex, '');
  return Number(output);
};

/**
 *　入力された文字列からカンマを排除し、返す関数
 */
String.prototype.removeComma = function (): string {
  const output = this ?? 'error'; // とりあえず、errorと返しておく
  // カンマ付き数字に対応
  return output.replaceAll(',', '');
};

/**
 *　入力された文字列からカンマ、ピリオド等の不必要な文字を排除し、numberで返す関数(不必要な文字が入っていた場合は、強制的に0.01に変換する)
 */
String.prototype.parseNumberStringAndRemoveString = function (): string {
  let output = this;
  // カンマ付き数字に対応
  output = output.replaceAll(',', '');
  // 文字が入っていた場合は0.01に変換
  if (isNaN(Number(output))) {
    return '0.01';
  }
  return output.toString();
};

/**
 * 文字列内にカンマがあった場合、エスケープした状態で文字列として返す
 * @returns string
 */
String.prototype.escapeStringComma = function (): string {
  let str = this;
  if (!str) return '';
  if (str.indexOf(',') > -1) {
    str = '"' + str + '"';
  }
  return str.toString();
};

/**
 * 文字列内の改行を削除する（勝手に改行が入るとcsvの行が増えてしまうため）
 * @returns string
 */
String.prototype.removeNewLineForText = function (): string {
  const str = this;
  return str.replace(/\r?\n/g, '');
};

/**
 * カンマ区切りの文字列を配列に変換する
 * カンマで区切られていない場合は、1要素の配列として返す
 * @param value - カンマ区切りの文字列
 * @returns string[]
 * @example "a,b,c".toStringArray() => ["a", "b", "c"]
 * @deprecated 拡張関数で代用
 */
export const commaStringToStringArray = (value: string): string[] => {
  if (!value) return [];
  return value.split(',').map((item) => item.trim());
};

/**
 * string | number | undefined　を stringに変換する
 * @deprecated 拡張関数で代用
 * @param value - 文字列
 */
export const filterStringNumberUndefinedToString = (value: string | number | undefined): string => {
  return value ? String(value) : '';
};
